export default __webpack_public_path__ + "static/media/portraitNominee.76387e53.png";